import {DispatchHolder} from '@local/logics/global/dispatchHolder';
import {snackbarActions} from '@local/redux/slice/snackbar';

/**
 * Snackbarを表示するやつ。
 * 毎回dispatch取り出してaction渡すのが微妙だったので作成
 */
export const snackbar = {
  error: (message: string, duration?: EpochMillis) => {
    DispatchHolder.dispatch(snackbarActions.error({message, duration}));
  },
  info: (message: string, duration?: EpochMillis) => {
    DispatchHolder.dispatch(snackbarActions.info({message, duration}));
  },
  success: (message: string, duration?: EpochMillis) => {
    DispatchHolder.dispatch(snackbarActions.success({message, duration}));
  },
  warning: (message: string, duration?: EpochMillis) => {
    DispatchHolder.dispatch(snackbarActions.warning({message, duration}));
  },
};
